import { Button, Modal } from "semantic-ui-react";
import { IParameter } from "../../models/parameter";
import { toast } from "../..";
import { hideParameter } from "../../services/parametersService";
import { useMemo } from "react";

interface IProps {
    hideParameterModalOpen: boolean;
    closeHideParameterModal: () => void;
    parameterToHide: IParameter;
    refreshParameters: () => void;
}

export const HideParameterModal = ({
    hideParameterModalOpen,
    closeHideParameterModal,
    parameterToHide,
    refreshParameters,
}: IProps) => {
    const textSuffix = useMemo(() => {
        return parameterToHide.hidden ? "un" : "";
    }, [parameterToHide.hidden]);
    const hiddenText = useMemo(() => {
        return parameterToHide.hidden ? "Unhide" : "Hide";
    }, [parameterToHide.hidden]);

    const handleHideParameter = async () => {
        const response = await hideParameter(parameterToHide.guid);
        if (response) {
            toast(`Parameter ${textSuffix}hidden successfully`, true, 2000);
            refreshParameters();
        } else {
            toast(`Error ${textSuffix}hiding parameter`, false, 2000);
        }
        closeHideParameterModal();
    };

    return (
        <Modal open={hideParameterModalOpen}>
            <Modal.Header>{`${hiddenText} parameter`}</Modal.Header>
            <Modal.Content>
                Are you sure you want to {textSuffix}hide parameter
                {parameterToHide.name}?
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={closeHideParameterModal} content="Cancel" />
                <Button primary onClick={handleHideParameter} content={`${hiddenText}`} />
            </Modal.Actions>
        </Modal>
    );
};
